import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const handleExpandedToggleTracking = (current: boolean, tableTitle: string) => {
  const event = current ? 'Collapse' : 'Expand';
  const eventAction = `${event} - ${tableTitle}`;
  GoogleTagManagerHelper.event(
    'Click',
    eventAction,
    'coefficients',
    { interaction: eventAction, section_reference: 'coefficients' },
    `table_${event.toLowerCase()}`,
  );
};

const handleRankingPageTracking = (path: string, type: 'ranking' | 'article', popover?: boolean) => {
  const pageName = `/nationalassociations/uefarankings/${path}/${popover ? 'about' : ''}`;

  if (pageName === GoogleTagManagerHelper.getFromDataLayer('pageName')) return;

  const gtmNewsletterFormInfo = {
    pageName,
    virtPath: pageName,
    pageType: type,
    pageSubType: 'coefficients',
    contentSection2: 'uefa rankings',
  };
  GoogleTagManagerHelper.addPageMeta(gtmNewsletterFormInfo);
  GoogleTagManagerHelper.addVirtualPage(gtmNewsletterFormInfo);
};
export const handleTablePageTracking = (path: string) => handleRankingPageTracking(path, 'ranking');
export const handlePopoverPageTracking = (path: string) => handleRankingPageTracking(path, 'article', true);
